import { handleValidationChange } from "../CommonValidations/CommonValidaions"

export const validateCheckUp = (data, setError) => {
  var isValid = true

  if (data.diagnosis === "") {
    handleValidationChange("diagnosis", true, setError)
    isValid = false
  } else {
    handleValidationChange("diagnosis", false, setError)
  }

  return isValid
}
export const validateOutpatientForm = (data, setError) => {
  var isValid = true

  if (data.professional_fee_method === "gcash" && !data.reference_no) {
    handleValidationChange("reference_no", true, setError)
    isValid = false
  } else {
    handleValidationChange("reference_no", false, setError)
  }

  if (data.professional_fee_method === "hmo" && !data.hmo_type) {
    handleValidationChange("hmo_type", true, setError)
    isValid = false
  } else {
    handleValidationChange("hmo_type", false, setError)
  }

  // if (data.professional_fee === "" || data.professional_fee === undefined) {
  //   handleValidationChange("professional_fee", true, setError)
  //   isValid = false
  // } else {
  //   handleValidationChange("professional_fee", false, setError)
  // }

  return isValid
}
